import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Table, Spinner, Alert } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

async function authGetJson(url) {
  const r = await authFetch(url);
  if (r && typeof r === "object" && !("ok" in r) && !("json" in r)) return r;
  if (r?.ok) return await r.json();
  const msg = r?.text ? await r.text() : "Request failed";
  throw new Error(msg);
}

export default function VatPickerModal({
  show,
  onHide,
  onPick,
  initialQuery = "",
}) {
  const [q, setQ] = useState(initialQuery);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(null);
  const [page, setPage] = useState(1);

  const limit = 30;

  const fetchPage = async (nextPage = 1, query = q) => {
    setBusy(true);
    setErr("");
    try {
      const url = `/bxvat/?skip=${(nextPage - 1) * limit}&limit=${limit}&q=${encodeURIComponent(
        (query || "").trim(),
      )}`;
      const data = await authGetJson(url);
      const list = data?.items || data || [];
      const t = data?.total ?? null;

      const mapped = list.map((v) => {
        const id = v.id ?? v.bxid;
        const procent = Number(v.procent ?? 0);
        const cod = v.cod ?? v.bxcod ?? "";
        const descr = v.descriere ?? v.bxdenumire ?? v.denumire ?? "";
        const label = cod;
        //   `${procent.toFixed(2)}% — ${cod}${descr ? " " + descr : ""}`.trim();
        return { id, procent, label, raw: v };
      });

      setItems(mapped);
      setTotal(t);
      setPage(nextPage);
    } catch (e) {
      setErr(String(e?.message || e));
      setItems([]);
      setTotal(null);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (!show) return;
    setQ(initialQuery || "");
    setItems([]);
    setTotal(null);
    setPage(1);
    setErr("");
    // arătăm lista la deschidere
    fetchPage(1, initialQuery || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const hasMore = total != null ? page * limit < total : items.length === limit;

  const pick = (opt) => {
    if (!opt) return;
    onPick?.({
      id: opt.id,
      procent: opt.procent,
      label: opt.label,
      raw: opt.raw,
    });
    onHide?.();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Alege TVA</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            fetchPage(1, q);
          }}
        >
          <div className="d-flex gap-2">
            <Form.Control
              autoFocus
              placeholder="Caută TVA... (Enter)"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <Button type="submit" disabled={busy}>
              Caută
            </Button>
          </div>
        </Form>

        <div className="mt-3">
          {busy ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner size="sm" />
              <span>Se încarcă...</span>
            </div>
          ) : (
            <>
              <Table hover size="sm" className="mb-0">
                <tbody>
                  {items.map((it) => (
                    <tr
                      key={String(it.id)}
                      role="button"
                      onClick={() => pick(it)}
                      style={{ cursor: "pointer" }}
                    >
                      <td style={{ width: 120, whiteSpace: "nowrap" }}>
                        #{it.id}
                      </td>
                      <td>{it.label}</td>
                    </tr>
                  ))}
                  {items.length === 0 && (
                    <tr>
                      <td className="text-muted">Nimic găsit.</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="d-flex justify-content-between align-items-center mt-2">
                <div className="text-muted" style={{ fontSize: 12 }}>
                  {total != null ? `Total: ${total}` : ""}
                </div>
                <div className="d-flex gap-2">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={busy || page <= 1}
                    onClick={() => fetchPage(page - 1, q)}
                  >
                    Înapoi
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={busy || !hasMore}
                    onClick={() => fetchPage(page + 1, q)}
                  >
                    Înainte
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
